import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { State } from '@progress/kendo-data-query';
import { User } from '@app/core/models';


@Component({
  selector: 'detail-credit-payments',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="960" title="Crédito: {{this.form.value.name}}" *ngIf="opened" (close)="onClose()">
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">
        
        <div class="row">
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Concepto:"></kendo-label>
                <p class="data-info k-color-info">
                  {{this.form.value.name}}
                </p>
            </div>
            <div class="col-xs-6 col-sm-6 example-col">
                <kendo-label text="Cliente:"></kendo-label>
                <p class="data-info k-color-info">
                  {{this.form.value.customer_name}}
                </p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Estatus:"></kendo-label>
                <p class="data-info" style="color: white; background-color: #{{this.form.value.status_payment_color}}; text-align: center;">
                  {{this.form.value.status_payment}}
                </p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Costo:"></kendo-label>
                <p class="data-info k-color-success right">
                  {{intl.formatNumber(this.form.value.cost, "c2")}}
                </p>
            </div>    
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Pagado:"></kendo-label>
                <p class="data-info k-color-success right">
                  {{intl.formatNumber(this.form.value.credit_paid, "c2")}}
                </p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Núm. de pagos:"></kendo-label>
                <p class="data-info k-color-success right">
                  {{this.form.value.credit_payments}}
                </p>
            </div>
            <div class="col-xs-3 col-sm-3 example-col">
                <kendo-label text="Pendiente:"></kendo-label>
                <p class="data-info k-color-error right">
                  <b>{{intl.formatNumber(this.form.value.credit_pending, "c2")}}</b>
                </p>
            </div>
            
        </div>

        <div class="row py-4">
          <div class="col-xs-12 col-sm-12 example-col">

            <kendo-grid [style.height.%]="100"
              [data]="payments"
              [selectable]="true"
              [reorderable]="true"
              [resizable]="true"
              #grid>

              <kendo-grid-column field="n" title="#" width="60" [filterable]="false">
                <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
                  # {{rowIndex + 1}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="id" title="Id" width="60" [hidden]="true"></kendo-grid-column>
              <kendo-grid-column field="date" title="Fecha" width="150">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
                  <kendo-grid-cell-date [text]="dataItem.date" [time]="false"></kendo-grid-cell-date>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="partiality" title="Parcialidad" width="80"></kendo-grid-column>
              <kendo-grid-column field="amount" title="Cantidad" width="120" format="{0:c}" [style]="{'text-align': 'right'}"></kendo-grid-column>      
              <kendo-grid-column field="payment_type_name" title="Tipo de pago" width="120"></kendo-grid-column>
              <kendo-grid-column field="person_name" title="Realizó" width="250"></kendo-grid-column>
              <kendo-grid-column field="created" title="Fecha de creación" width="200" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
                  <kendo-grid-cell-date [text]="dataItem.created" [time]="true"></kendo-grid-cell-date>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="modified" title="Fecha de modificación" width="200" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
                  <kendo-grid-cell-date [text]="dataItem.modified" [time]="true"></kendo-grid-cell-date>
                </ng-template>
              </kendo-grid-column>

            </kendo-grid>
              
          </div>
        </div>
      </div>
    </form>
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
    p.data-info {
      margin-bottom: 0px;
      // font-weight: bold;
      margin-top: 8px;
      padding: 6px;
      // background-color: #ecf0f1;
      border: 1px solid #ecf0f1;
      min-height: 30px;
    }
    p.right {
      text-align: right;
    }
    .k-numeric-wrap .k-input, k-formatted-value{
      text-align:right
    }
  `],
  providers: [ DatasourceService ]
})
export class DetailCreditPaymentsComponent extends CreateEditWindowComponent {

  @Input() id: number = 0;

  @Input() type: string = '';

  protected payments: Array<any> = [];

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);    
    
  }

  //@Override
  public edit(dataItem: any, rowIndex: number = null): void {

    this.mode = 'EDIT';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, dataItem)
    this.payments = [];

    this.service.post('credit_pays', { id: dataItem.id, type: dataItem.type})
      .subscribe(
        (res) => {
          console.log("RESPONSE------: ", res);
          this.payments = res.payments;            
        },
        (fail) => {        
          console.log("Error", fail);
        }
      );
  
  }  

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {    

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),
      'name': new FormControl((dataItem) ? dataItem.name: ""), 
      'customer_name': new FormControl((dataItem) ? dataItem.customer_name: ""), 
      'cost': new FormControl((dataItem) ? dataItem.cost: ""),  
      'credit_paid': new FormControl((dataItem) ? dataItem.credit_paid: ""),  
      'credit_pending': new FormControl((dataItem) ? dataItem.credit_pending: ""),  
      'credit_payments': new FormControl((dataItem) ? dataItem.credit_payments: ""), 
      'status_payment': new FormControl((dataItem) ? dataItem.status_payment: ""), 
      'status_payment_color': new FormControl((dataItem) ? dataItem.status_payment_color: ""), 
    });    

  };


}
